import { DialogContent } from '@material-ui/core';
import styled from 'styled-components';

export const StyledDialogContent = styled(DialogContent)`
  padding: 20px;
`;
